import { createSlice, createSelector } from "@reduxjs/toolkit";

const interfaceApiSlice = createSlice({
  name: "interfaceAPI",
  initialState: {
    isLoading: false,
    loaderMessage: "",
    isLoadingNewAdd: false,
    interfaceList: {
      lists: [],
      totalCount: 0,
    },
    appDocList: [],
    repoDocList: [],
  },
  reducers: {
    startInterfaceApiList(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    startDeleteInterfaceApiList(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    setInterfaceApiListData(state, action) {
      state.interfaceList = action.payload;
    },
    startInterfaceFilterApiList(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait...";
    },
    setInterfaceFilterApiListData(state, action) {
      state.interfaceList = action.payload;
    },
    startAppDocInteraceApiList(state, action) {
      state.isLoadingNewAdd = true;
    },
    setInterfaceAppDocList(state, action) {
      state.appDocList = action.payload;
    },
    startRepoDocInteraceApiList(state, action) {
      state.isLoadingNewAdd = true;
    },
    setInterfaceRepoDocList(state, action) {
      state.repoDocList = action.payload;
    },
    startAddNewInteraceApi(state, action) {
      state.isLoadingNewAdd = true;
    },
    startStatusNewInteraceApi(state, action) {
      state.isLoadingNewAdd = true;
    },
    completedFetch(state, action) {
      state.isLoading = false;
      state.loaderMessage = "";
    },
    completedNewAdd(state, action) {
      state.isLoadingNewAdd = false;
      state.loaderMessage = "";
    },
  },
});

export const {
  startInterfaceApiList,
  startDeleteInterfaceApiList,
  setInterfaceApiListData,
  startInterfaceFilterApiList,
  setInterfaceFilterApiListData,
  startAppDocInteraceApiList,
  setInterfaceAppDocList,
  startRepoDocInteraceApiList,
  setInterfaceRepoDocList,
  completedFetch,
  startAddNewInteraceApi,
  startStatusNewInteraceApi,
  completedNewAdd,
} = interfaceApiSlice.actions;

export default interfaceApiSlice.reducer;

///selector
const mainReducer = (state) => state.InterfaceApi;
//
export const isLoadingSelector = createSelector(
  [mainReducer],
  (myReducerStore) => myReducerStore.isLoading
);
//
export const interfaceApiListSelector = createSelector(
  [mainReducer],
  (myReducerStore) => myReducerStore.interfaceList
);
//
export const interfaceApiAppDocListSelector = createSelector(
  [mainReducer],
  (myReducerStore) => myReducerStore.appDocList
);
//
export const interfaceApiRepoDocListSelector = createSelector(
  [mainReducer],
  (myReducerStore) => myReducerStore.repoDocList
);
//
export const loaderMessageSelector = createSelector(
  [mainReducer],
  (myReducerStore) => myReducerStore.loaderMessage
);
//
